import { recordPath, recordRoute } from '@/shared/registry'

/** Where the assessment pages live. */
export const assessmentsPath = '/catalog/assessments'
export const createAssessmentPath = `${assessmentsPath}/new`
export const assessmentRoute = recordRoute('catalog', 'assessments')
export const editAssessmentRoute = `${assessmentRoute}/edit`
export const designAssessmentRoute = `${assessmentRoute}/design`
export const previewAssessmentRoute = `${assessmentRoute}/preview`

/** An assessment's details page. */
export function assessmentPath(id: string): string {
  return recordPath('catalog', 'assessments', id)
}

/** The base of Assessment Details' slots (`detailsSlots`), such as Launch's Find Responses. */
export const assessmentDetailsSlot = 'catalog.assessment-details'

/** The API's assessment endpoints. */
export const assessmentsApi = '/catalog/v1/assessments'

export function assessmentApi(id: string): string {
  return `${assessmentsApi}/${encodeURIComponent(id)}`
}

/** An assessment's questions, with which answers are correct: for the designer and preview. */
export function assessmentQuestionsApi(id: string): string {
  return `${assessmentApi(id)}/questions`
}

/** What each assessment action needs. */
export const readAssessmentsPermission = 'catalog.assessments.read'
export const writeAssessmentsPermission = 'catalog.assessments.write'
export const deleteAssessmentsPermission = 'catalog.assessments.delete'
